module.exports = __webpack_public_path__ + "img/vertical-dots.c5c117de.svg";